import { InjectionToken } from '@angular/core';
import { Selector } from '@ngrx/store';

/**
 * Injection token for providing the router URL selector.
 *
 * This decouples the SignalR service from the specific router store implementation.
 * The app should provide the concrete selector (e.g., RouterStoreSelectors.selectUrl).
 *
 * Example usage:
 * ```ts
 * { provide: SIGNALR_URL_SELECTOR, useValue: RouterStoreSelectors.selectUrl }
 * ```
 */
export const SIGNALR_URL_SELECTOR = new InjectionToken<Selector<object, string>>('SIGNALR_URL_SELECTOR');

// Important:
// The router URL selector lives in the app-specific store (`@era/stores`).
// We expose it via this InjectionToken so the shared SignalR service does not
// need to import `@era/stores` directly. Providing the selector from `main.ts`
// avoids feature coupling and helps prevent circular dependency evaluation.
